export function bytesToGB(bytes: number, floatingPoint = 1) {
  return +(bytes / 1_000_000_000).toFixed(floatingPoint);
}
